import * as React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "components/controls/widget";


interface ConfirmDialogProps {
    show: boolean;
    title: string;
    onResult: (confirm: boolean) => void;
    content: () => React.ReactNode;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
    fullWidth?: boolean;
}

class ConfirmDialog extends React.PureComponent<ConfirmDialogProps> {
    render() {
        const { show, title, onResult, content, maxWidth, fullWidth } = this.props;
        return <Dialog open={show} scroll="paper" fullWidth={fullWidth} maxWidth={maxWidth}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>{show ? content() : null}</DialogContent>
            <DialogActions>
                <Button color="primary" variant="contained" onClick={() => onResult(true)}>{'Ano'}</Button>
                <Button variant="contained" onClick={() => onResult(false)}>{'Ne'}</Button>
            </DialogActions>
        </Dialog>
    }
}



export default ConfirmDialog;
